import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DaywiseProductionModel } from './day-wise-production-model';

export class DaywiseProductionResponseModel extends GlobalResponseObject {
    data: DaywiseProductionModel[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data: DaywiseProductionModel[]){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}